import store from "src/store"

export const handleError = (err: any) => {
  if (err.response && err.response.status) {
    if (err.response.status === 401) {
      store.dispatch.userLogin.setIsOpen(true)
    }
  }
}